import * as serviceWorker from './serviceWorker';
import App from './App';
import { configureStore } from './redux/store';
import { Provider } from 'react-redux';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from 'history';
import { Auth0Provider } from '@auth0/auth0-react';

// Allow routing to work properly in S3.
const history = createBrowserHistory();
const path = ( /#!(\/.*)$/.exec( window.location.hash ) || [] )[1];
if ( path ) {
	history.replace( path );
}

if ( process.env.NODE_ENV === 'development' ) {
	// For Cypress.
	require( 'whatwg-fetch' );
}

const container = document.getElementById( 'root' );
const root = createRoot( container );

root.render(
	<Auth0Provider
		domain={process.env.REACT_APP_AUTH0_DOMAIN}
		clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
		useRefreshTokens={true}
		cacheLocation="localstorage"
		authorizationParams={{
			redirect_uri: window.location.origin,
			audience: process.env.REACT_APP_AUTH0_AUDIENCE,
		}}
	>
		<Provider store={configureStore()}>
			<App />
		</Provider>
	</Auth0Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
